import React from "react";
import logo from "../../assets/images/logo.png";
import { Link } from "react-router-dom";

const GoatFightFooter = () => {
    return (
        <footer className="gf-footer">
            <div className="gf-footer-inner">
                <Link to="/">
                    <img src={logo} alt="Goat Fight" />
                </Link>

                <nav className="gf-footer-nav">
                    <Link to="/aboutus">ABOUT</Link>
                    <Link to="/howtoplay">HOW IT WORKS</Link>
                    <Link to="/disclaimer">TERMS OF SERVICE</Link>
                    <Link to="/privacypolicy">PRIVACY POLICY</Link>
                    <Link to="/contactus">CONTACT US</Link>
                </nav>

                 <small>
                    © 2026 GoatFight. All rights reserved.
                </small>
            </div>
        </footer>
    );
};

export default GoatFightFooter;